<template>
  <div class="dashboardAdmin-parentdiv bluebtn">
    <div
      class="
        dashboardAdmin-header
        d-flex
        justify-content-between
        align-items-center
        mt-4
      "
    >
      <div class="dashboardAdmin-header-main-head">
        <span>Teams</span>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <div class="d-flex switchParent ml-2">
          <div
            class="switchChild"
            @click="toggleSwitch(true)"
            :class="{
              activeSwitchLeft: listView,
              notActiveSwitchLeft: !listView,
            }"
          >
            List View
          </div>
          <div
            class="switchChild"
            @click="toggleSwitch(false)"
            :class="{
              activeSwitchRight: !listView,
              notActiveSwitchRight: listView,
            }"
          >
            Hierarchical View
          </div>
        </div>
        <div v-if="roles.includes('PUSH_TEAMS')" class="ml-2">
          <b-button
            :disabled="!roles.includes('PUSH_TEAMS')"
            class="
              new-blueBtn
              w-100
              d-flex
              align-items-center
              justify-content-center
            "
            v-b-modal.addfolder
          >
            <img
              src="../../assets/New-imgs/teams-icons/plus-btn.svg"
              alt=""
              class="mr-2"
            />
            <span> Group </span>
          </b-button>
        </div>
      </div>
    </div>
    <template v-if="listView">
      <TeamsFolder />
    </template>
    <template v-else>
      <TeamsGridView @switch-to-list-view="switchToListView" :canEdit="true" />
    </template>

    <!-- add modal -->
    <b-modal
      id="addfolder"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="closeModel('addfolder')"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="teams-modal-head">New Group</div>
        <div @click="closeModel('addfolder')">
          <img
            src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
            alt=""
            class="pointer rotate-on-hover"
          />
        </div>
      </div>
      <div class="mt-3">
        <div class="topDiv">
          <label class="teams-label-font">Group Name</label>
          <b-form-input
            class="mt-2 teams-inputField"
            type="text"
            placeholder="Enter Group Name"
            v-model.trim="$v.folderName.$model"
            :class="{ error: $v.folderName.$error }"
            @keyup.enter="createFolder"
            autofocus
          ></b-form-input>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end mt-5">
        <b-button class="new-whiteBtn mr-3" @click="closeModel('addfolder')"
          >Cancel</b-button
        >
        <b-button
          class="new-blueBtn"
          @click="createFolder"
          :disabled="folderName == ''"
          >Create</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import EventBus from "../../utils/eventBus.js";
import { mapGetters } from "vuex";
import toast from "../../components/mixin/toast";
import { addFolder } from "../../utils/apiFunctions";
import TeamsFolder from "./TeamsFolder.vue";
import TeamsGridView from "./TeamsGridView.vue";
import { required, maxLength } from "vuelidate/lib/validators";
import teamsMixin from "../../components/mixin/teamsMixin";
export default {
  name: "Teams",
  components: {
    TeamsFolder,
    TeamsGridView,
  },
  data() {
    return {
      folderName: "",
      listView: true,
    };
  },
  validations() {
    return {
      folderName: {
        required,
        maxLength: maxLength(64),
      },
    };
  },
  async created() {
    this.$store.commit("teamsVUEX/addFolderContent", {});
    this.$store.commit("teamsVUEX/setActive", "");
    this.$store.commit("teamsVUEX/setLoader", false);
  },
  mixins: [toast, teamsMixin],
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    toggleSwitch(value) {
      this.listView = value;
      this.$forceUpdate();
    },
    switchToListView() {
      this.listView = true;
    },
    // CREATE FOLDER
    async createFolder() {
      this.$v.$touch();
      if (this.$v.folderName.$error) {
        this.errorModal("Please give folder name");
      } else {
        try {
          let payload = {
            licenseKey: this.getlicenseKey,
            folderName: this.folderName,
            parentFolderID: null,
            project: "recruitment",
          };
          const response = await addFolder(payload);
          if (response.status == 200) {
            const id = response.data.data.folderID;
            this.$store.commit("teamsVUEX/setActive", id);
            this.closeModel("addfolder");
            this.successModal("Folder created successfully");
            this.$v.folderName.$model = "";
            EventBus.$emit("on-create");
          } else {
            this.errorModal(response.data.data.Detail);
          }
          this.$v.$reset();
        } catch (error) {
          this.errorModal("Something went wrong");
        }
      }
    },

    // DYNAMIC CLASS FOR CLOSING MODEL
    closeModel(model) {
      this.$bvModal.hide(model);
      this.$v.$reset();
      this.folderName = "";
    },
  },
};
</script>

<style>
.green-bar {
  position: absolute;
  width: 3px;
  height: 90%;
  top: 5%;
  background: #49be9b;
  left: 3px;
  border-radius: 10px;
}

.search-user-head {
  font-size: 14px;
  font-size: 400;
  color: #72738e;
}

.tag-user {
  font-size: 14px;
  font-size: 500;
  color: #72738e;
}

.preview-feedbck-container {
  background: #ffffff;
  box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  padding: 15px;
}

.folder-right-foldercontainer {
  background: #fcfcfc;
  border: 1px solid #ededed;
  box-shadow: 0px 16px 40px rgba(129, 128, 128, 0.25);
  border-radius: 4px;
  padding: 15px;
  width: 320px;
  height: 105px;
}

.right-folder-mainheading {
  font-weight: 600;
  font-size: 18px;
  color: #464667;
}

.folder-count-box {
  background: #f1f1f1;
  border: 1px solid #ededed;
  border-radius: 4px;
  width: 40px;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.teams-empty-svg {
  position: absolute;
  transform: translate(75%, 50%);
}

.root-folder-box {
  background: #fcfcfc;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.root-folder-active-box {
  background: #3e85bd;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.root-folder-text {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}

.gridgreencolorDynamic {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  top: 2px;
  left: 3px;
  background: #696969;
}

.gridwhitecolor {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  top: 2px;
  left: 3px;
  background: #f6f6f6;
}

.root-folder-active-text {
  font-weight: 500;
  font-size: 14px;
  color: #fcfcfc;
}

.right-folder-txt {
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}

.user-list {
  height: 165px;
  overflow-y: scroll;
}

.users-list {
  margin-top: 5px;
  border-radius: 5px;
  background: #ffffff;
  border: 0.7px solid rgba(114, 115, 142, 0.5);
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.12);
}

.user-list-head {
  font-size: 14px;
  font-weight: 400;
  color: #6d6d6d;
}

.selected {
  background: #f4f4f4;
}

.select-users {
  margin-right: 15px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  background: #e7e8f5;
  border-radius: 3px;
}

.user-name {
  padding: 3px 10px 2px 10px;
  font-size: 13px;
  font-weight: 400;
  color: #696969;
}

.close-img {
  padding-right: 8px;
}
</style>
